import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PaginationLimit } from "../../Config";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import { useNavigate } from "react-router-dom";

const Tables = ({ ApiData, setSelectedData, setViewDetail }) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);

  const navigate = useNavigate();

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getGender = (gender) => {
    if (gender === 1) {
      return "Male";
    } else {
      return "Female";
    }
  };

  const getClientName = (item) => {
    return (
      <div className="flex gap-2 items-center">
        <div className="flex flex-col gap-1">
          <span className="text-zinc-900 font-semibold">{item.clientName}</span>
          <span className="text-yellow-500 text-xs">#{item.clientMobile}</span>
        </div>
      </div>
    );
  };

  // const getClientName = (item) => {
  //   return (
  //     <div
  //       className="flex gap-2 items-center"
  //       onClick={(e) => {
  //         e.stopPropagation();
  //         navigate(`/activelogs/${item.clientId}`);
  //       }}
  //     >
  //       <div className="flex flex-col gap-1">
  //         <span className="text-zinc-900 font-semibold">
  //           {item.clientName}{" "}
  //         </span>
  //         <span className="text-yellow-500 text-xs">#{item.clientMobile}</span>
  //       </div>
  //     </div>
  //   );
  // };

  const getLastLogin = (item) => {
    if (item.lastLogin == null) {
      return <p>--</p>;
    } else if (item.lastLogin) {
      return <p>{item.lastLogin}</p>;
    }
  };

  const onRowClick = (client) => {
    setSelectedData(client); // full client object
    setViewDetail(true);
  };

  const getClientLastLogin = (staffs = []) => {
    if (staffs.length === 0) return "N/A";
    const latestStaff = staffs.reduce((latest, current) => {
      return new Date(current.lastLogin) > new Date(latest.lastLogin)
        ? current
        : latest;
    });
    return latestStaff.lastLogin;
  };

  useEffect(() => {
    if (ApiData) {
      // const staffOnly = ApiData.flatMap((c) => c.staffs);
      const tempData = ApiData.map((item) => ({
        item,
        lastLogin: <p>{getClientLastLogin(item?.staffs)}</p>,
        clientName: getClientName(item) || "NA",
        Gender: item.gender === 1 ? "Male" : "Female",
        Number: <div className="text-yellow-500">#{item.mobile}</div>,
        // businessName: item.businessName ? (
        //   <div>{item?.businessName}</div>
        // ) : (
        //   "----"
        // ),
        businessName: (
          <div
            className="cursor-pointer text-black-600"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/activelogs/${item.clientId}`);
            }}
          >
            {item.businessName ? item.businessName : "----"}
          </div>
        ),
        Salary:
          item.salary === 0 ? <div>--/--</div> : <div> ₹ {item.salary}</div>,
        staffCount: <p>#{item?.staffCount}</p>,
        status:
          item.status === 1 ? (
            <div className="bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full">
              Active
            </div>
          ) : (
            <div className="bg-gray-100 text-gray-700 text-xs border-gray-300 border w-24 h-7 flex items-center justify-center rounded-full">
              Inactive
            </div>
          ),
      }));
      setData(tempData);
    }
  }, [ApiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const columns = useMemo(() => {
    if (isMobileView) {
      // Display only "User" column for mobile screens
      return [
        {
          Header: "Client Name",
          accessor: "clientName",
        },
        {
          Header: "Staff Count",
          accessor: "staffCount",
        },
      ];
    }

    // Columns for larger screens
    return [
      {
        Header: "Client Name",
        accessor: "clientName",
      },
      {
        Header: "Business Name",
        accessor: "businessName",
      },
      {
        Header: "Staff Count",
        accessor: "staffCount",
      },
      {
        Header: "Last Login",
        accessor: "lastLogin",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );
  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);
  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(ApiData?.length > 0).toString()}
        >
          {/* <Tbody {...getTableBodyProps()} className={ApiData?.length > 0 ? "border-b" : ""}> */}
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  className="cursor-pointer"
                  {...row.getRowProps()}
                  hasdata={(ApiData?.length > 0).toString()}
                  onClick={() => onRowClick(row.original.item)}
                >
                  {/* <Tr
                  {...row.getRowProps()}
                  className={ApiData?.length > 0 ? "border-b" : ""}
                > */}
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>City:</strong> {data[rowIndex].city}
                        </li>
                        <li>
                          <strong>Created At:</strong> {data[rowIndex].date}
                        </li>
                        <li className="flex gap-2">
                          <strong>Status:</strong> {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75 "
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${(props) =>
  props.hasdata === "true" ? "border-b" : ""}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
export default Tables;
